export const worldcupCache = {
  rank: null,
  schedules: {},
  teamSchedules: {},
  newsPages: {},
  newsDetails: {}
}
